<div class="flex header-container" [style.min-height]="minHeight" [class.p-top]="soAndAoCollapse">
  <!-- Flecha (siempre visible excepto si hideArrow) -->
  <div *ngIf="!hideArrow" class="flex arrow-container">
    <app-st-icon [ngClass]="{'rotate': panelActive}" class="ant-collapse-arrow" name="keyboard_arrow_right"></app-st-icon>
  </div>
  
  <!-- Solo texto simple (cuando onlyText está definido) -->
  <div *ngIf="onlyText" class="only-text-container" [class.lh-2]="soAndAoCollapse">
    <app-st-icon *ngIf="isWarning" [name]="'warning'" [bold]="true" [color]="'#FF990A'" [filled]="true"></app-st-icon>
    <strong>{{onlyText}}</strong>
  </div>
  
  <!-- Contenido complejo (cuando onlyText NO está definido) -->
  <div *ngIf="!onlyText">
<!--    <label class="text-label-12 text-semibold">{{code}}</label>-->
    <div class="flex-center-between gap-200 core">
      <div class="flex-center gap-100">
        <label *ngIf="showCheckbox" nz-checkbox 
               [nzChecked]="isChecked"
               (nzCheckedChange)="onCheckboxChange($event)"
               (click)="$event.stopPropagation()"></label>
        <h3 (click)="navigationEvent.emit(); $event.stopPropagation()" [style.font-size]="titleFontSize"
           class="text-header-16 text-nowrap transition-02">{{name}}</h3>
      </div>
      <div class="flex-center gap-100">
        <span *ngIf="showStateBadge && (state | projectState) as stateData" class="st-badget"
              [ngClass]="[ stateData.class, ((isMobile$ | async) ? 'small' : '') ]">
          <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
          <label>{{ stateData.name }}</label>
        </span>
        <div *ngIf="date && !(isMobile$ | async)" class="flex-center gap-075 color-grey-9">
          <app-st-icon [bold]="true" name="calendar_today"></app-st-icon>
          <span class="text-label-14 text-nowrap">{{date | date:'d MMM' | uppercase}}</span>
        </div>
      </div>

      <!-- Acciones siempre visibles -->
      <app-action-btns
        [copy]="actions.copy"
        [file]="actions.file"
        [message]="actions.message"
        [drawer]="actions.drawer"
        [select]="actions.select"
        [selectList]="selectList"
        (buttonClick)="onAction($event)"
      ></app-action-btns>

      <!-- Fila de fecha y acciones para móvil -->
      <div *ngIf="(isMobile$ | async)" class="mobile-date-actions-row">
        <div *ngIf="date" class="flex-center gap-075 color-grey-9">
          <app-st-icon [bold]="true" name="calendar_today"></app-st-icon>
          <span class="text-label-14 text-nowrap">{{date | date:'d MMM' | uppercase}}</span>
        </div>

        <div class="mobile-actions-container">
          <app-action-btns
            [copy]="actions.copy"
            [file]="actions.file"
            [message]="actions.message"
            [drawer]="actions.drawer"
            [select]="actions.select"
            [selectList]="selectList"
            (buttonClick)="onAction($event)"
          ></app-action-btns>

          <button *ngIf="showDropdownMenu && (permissions?.edit || permissions?.delete)"
                  nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
                  [nzDropdownMenu]="actionMenu" nzTrigger="click"
                  (click)="$event.stopPropagation()">
            <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
          </button>
        </div>
      </div>

      <!-- Acciones solo para desktop -->
      <div *ngIf="!(isMobile$ | async)">
      <app-action-btns
        [copy]="actions.copy"
        [file]="actions.file"
        [message]="actions.message"
        [drawer]="actions.drawer"
        [select]="actions.select"
        [selectList]="selectList"
        (buttonClick)="onAction($event)"
      ></app-action-btns>

      <button *ngIf="showDropdownMenu && (permissions?.edit || permissions?.delete)" 
              nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
              [nzDropdownMenu]="actionMenu" nzTrigger="click"
              (click)="$event.stopPropagation()">
        <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
      </button>
      </div>

      <nz-dropdown-menu #actionMenu="nzDropdownMenu">
        <ul nz-menu>
          <li *ngIf="permissions?.edit" nz-menu-item (click)="onEditClick()">
            <div class="flex-center gap-100">
              <app-st-icon name="edit" [bold]="true"></app-st-icon>
              <span class="text-label-14 text-dark">Editar</span>
            </div>
          </li>
          <li *ngIf="permissions?.delete" nz-menu-item (click)="onDeleteClick()">
            <div class="flex-center gap-100">
              <app-st-icon name="delete" [bold]="true"></app-st-icon>
              <span class="text-label-14 text-dark">Eliminar</span>
            </div>
          </li>
        </ul>
      </nz-dropdown-menu>

<!--      <div *ngIf="date" class="flex-center gap-075 color-grey-9">-->
  </div>

  <div *ngIf="soAndAoCollapse && soAndAoCollapse.length === 0" class="st-badget subtle-amber">
    <app-st-icon [bold]="true" [name]="'error'"></app-st-icon>
    <label>No hay {{isIngreso ? 'Ingresos' : 'Gastos'}} en esta Orden de servicio</label>
</div>
